import { render, staticRenderFns } from "./AudioElement.vue?vue&type=template&id=656845dc&scoped=true&"
import script from "./AudioElement.vue?vue&type=script&lang=ts&"
export * from "./AudioElement.vue?vue&type=script&lang=ts&"
import style0 from "./AudioElement.vue?vue&type=style&index=0&id=656845dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656845dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VProgressCircular,VRow,VTooltip})
